import React from 'react';
import { Box } from '@mui/material';

interface LogoProps {
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ size = 48 }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="sakuraGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#F48FB1" />
            <stop offset="50%" stopColor="#E91E63" />
            <stop offset="100%" stopColor="#880E4F" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        
        <path
          d="M50 10 C50 10 70 30 70 50 C70 70 50 90 50 90 C50 90 30 70 30 50 C30 30 50 10 50 10 Z"
          fill="url(#sakuraGradient)"
          filter="url(#glow)"
        />
        
        <path
          d="M50 20 C50 20 62 35 62 50 C62 65 50 80 50 80 C50 80 38 65 38 50 C38 35 50 20 50 20 Z"
          fill="rgba(255, 255, 255, 0.3)"
        />
        
        <ellipse cx="30" cy="45" rx="8" ry="12" fill="url(#sakuraGradient)" transform="rotate(-30 30 45)" />
        <ellipse cx="70" cy="45" rx="8" ry="12" fill="url(#sakuraGradient)" transform="rotate(30 70 45)" />
        <ellipse cx="35" cy="60" rx="6" ry="10" fill="url(#sakuraGradient)" transform="rotate(-45 35 60)" />
        <ellipse cx="65" cy="60" rx="6" ry="10" fill="url(#sakuraGradient)" transform="rotate(45 65 60)" />
      </svg>
    </Box>
  );
};

export default Logo;
